export const eligibilityQuestions = [
  {
    id: 'unrepairedDamage',
    question:
      'Is there any unrepaired damage or history of water damage claims on any dwelling or structure on this application?'
  },
  {
    id: 'priorFireLoss',
    question:
      'Has any applicant or household member sustained a prior fire loss, or has there been a fire on any premise in the last 10 years?'
  },
  {
    id: 'priorLiabilityLoss',
    question:
      'Has any applicant or household member sustained a prior liability loss, or had a claim made against them?'
  },
  {
    id: 'chargedWithFelony',
    question: 'Has any applicant or household member ever been charged with a felony?'
  },
  {
    id: 'foreclosureBankruptcy',
    question:
      'Has the applicant had a foreclosure, repossession, bankruptcy, or filed for bankruptcy during the past 5 years?'
  },
  {
    id: 'coverageDeclined',
    question: 'Has any coverage been declined, cancelled or non renewed during the last 3 years?'
  }
];

export const propertyRiskFactorQuestions = [
  {
    id: 'otherResidences',
    question:
      'Does the applicant have any other residences that are not listed on this application, whether owned, occupied, or rented?',
    label: 'Provide address and occupancy details (owned, occupied, or rented) for all offlisted residences'
  },
  {
    id: 'dwellingsForSale',
    question: 'Are there any dwellings or homes for sale that are listed on this application?',
    label: 'Provide addresses of the dwellings or homes for sale, along with any liens related to the sale'
  },
  {
    id: 'unlistedStructures',
    question: 'Are there any structures on the premises that are not listed or that should be excluded?',
    label:
      'Provide details of all unlisted structures on the premises, and list of any structures the applicant wants to exclude with the reason for each exclusion'
  },
  {
    id: 'recreationalVehicles',
    question: 'Are there any recreational vehicles the applicant owns that are not included in this application?',
    tooltip: 'Including but not limited to, snow mobiles, dune buggies, mini bikes, ATVs, etc.',
    label: 'Provide the type, make, models and usage details for all unlisted recreational vehicles'
  },
  {
    id: 'livestockFencing',
    question: 'Is the fencing for livestock on the premises in good repair?',
    tooltip: 'If there are no livestock on the premise, please select "Yes."',
    label: 'Provide a description of condition and type of fencing used for livestock on premises',
    showDetailsWhen: ['false', false]
  },
  {
    id: 'livestockEscape',
    question: 'Has there ever been an incident of livestock escape?',
    tooltip: 'If there are no livestock on the premise, please select "No"',
    label: 'Provide details of each livestock escape incident'
  },
  {
    id: 'solarPanels',
    question: 'Are there any solar panels on the premises?'
  },
  {
    id: 'dogsOrExoticPets',
    question: 'Are there any dogs or exotic pets kept on premises?',
    label:
      'Provide the type of each exotic pet, or if dog, the breed, the bite history, and a brief explanation if there is any history of biting incidents'
  },
  {
    id: 'trampoline',
    question: 'Is there a trampoline on the premises?',
    label:
      'Provide the amount of trampolines, along with details about the presence of safety nets and jump guards for each'
  },
  {
    id: 'dwellingsUnderRenovation',
    question: 'Are there any dwellings/structures under renovation or construction?',
    label: 'Provide details about the dwellings or structures under renovation or construction'
  }
];

export const operationalDetailsQuestions = [
  {
    id: 'businessConductedOnPremises',
    question: 'Is any business conducted on the premises?',
    tooltip: 'Including but not limited to, farming, home office or business, telecommuters, etc.',
    label: 'Provide details about each type of business conducted on the premises'
  },
  {
    id: 'dayCareBusiness',
    question: 'Is there any day care business conducted on the premises?',
    label: 'Provide details related to the day care, and include the number of children'
  },
  {
    id: 'anhydrousAmmoniaEquipment',
    question:
      'Does any insured own anhydrous ammonia or weed spraying equipment for use on the premises or any other property?'
  },
  {
    id: 'processOrManufacture',
    question: 'Does the applicant process or manufacture any of their own products?'
  },
  {
    id: 'huntingOrFishingFee',
    question: 'Does the applicant allow hunting or fishing for a fee on any premises?'
  },
  {
    id: 'customFarming',
    question: 'Does the applicant do any custom farming?',
    label:
      "Provide details related to total acres custom farmed, total receipts, any prior liability claims, and if any custom farming is done outside of the insured's state"
  }
];
